export let globalType = 'public' // public or private 共有云，私有云
// 七牛上传地址
export const qiniuUploadUrl = 'https://upload-z1.qiniup.com'
// 七牛临时库下载地址
export const qiniuDownloadTmp = process.env.VUE_APP_ENV === 'test' ? 'https://m7-mopower-test.7moor.com/' : 'https://7-mopower-private.7moor.com/'
// 私有云上传地址
// export const qiniuUploadUrl = '/mopower-ftp/api/support/ftps'
// 私有云下载地址
// export const qiniuDownloadTmp = '/mopower-ftp/api/support/ftps/'

// 预定义颜色
export const predefineColors = [
  'rgba(26, 140, 255, 0.7)',
  'rgba(47, 203, 235, 0.7)',
  'rgba(65, 217, 116, 0.7)',
  'rgba(123, 217, 76, 0.7)',
  'rgba(255, 196, 77, 0.7)',
  'rgba(255, 136, 77, 0.7)',
  'rgba(250, 87, 87, 0.7)',
  'rgba(255, 77, 166, 0.7)',
  'rgba(158, 109, 242, 0.7)',
  'rgba(128, 128, 255, 0.7)',
  'rgba(26, 140, 255, 1)',
  'rgba(47, 203, 235, 1)',
  'rgba(65, 217, 116, 1)',
  'rgba(123, 217, 76, 1)',
  'rgba(255, 196, 77, 1)',
  'rgba(255, 136, 77, 1)',
  'rgba(250, 87, 87, 1)',
  'rgba(255, 77, 166, 1)',
  'rgba(158, 109, 242, 1)',
  'rgba(128, 128, 255, 1)'
]
export const MESSAGE_TYPE = () => {
  return {
    INNER: '站内信',
    SYSTEM: '系统消息'
  }
}
